import { LocaleProvider } from '@vp/digital-locale-lib-ubik'
import { IdentityProvider, LoggerProvider, useSwanStyleKeys, VPAuthConfig } from '@vp/ubik-context'
import WebsShutdownPage from './src/WebsShutdownPage'
import { getClientEnvironment, RuntimeContextProvider } from '@vp/digital-environment-lib-ubik'
import { ScreenClassProvider } from '@vp/swan'

const createAuthConfig = (culture: string, isDevelopment: boolean): VPAuthConfig => ({
  culture,
  developmentMode: isDevelopment,
  options: {
    requireSession: true,
    customText: 'Sign in to see your account',
  },
})

export function WebsShutdownApp(props: any) {
  // Use the hook to apply the Swan style keys
  useSwanStyleKeys(['core', 'button'])
  return (
    <LoggerProvider>
      <LocaleProvider rawLocaleIdentifier={props.locale}>
        <RuntimeContextProvider getEnvironment={getClientEnvironment}>
          <IdentityProvider auth={createAuthConfig(props.locale, false)}>
            <ScreenClassProvider>
              <WebsShutdownPage {...props} />
            </ScreenClassProvider>
          </IdentityProvider>
        </RuntimeContextProvider>
      </LocaleProvider>
    </LoggerProvider>
  )
}
